<template>
  <el-drawer
      :title="type == 'VIEW' ? '查看页面配置' : '编辑页面配置'"
      :close-on-click-modal="false"
      size="60%"
      destroy-on-close
      :visible.sync="visible">
    <!-- 标题 -->
    <el-form ref="formRef" :inline="true" :model="info" :rules="formRules" size="small">
      <el-form-item label="标题" prop="title">
        <el-input v-model="info.title" placeholder="配置标题" clearable :disabled="type == 'VIEW'" />
      </el-form-item>
      <el-form-item label="页面类型" prop="no">
        <el-select class="item-choose" v-model="info.no" clearable placeholder="请选择"  :disabled="type == 'VIEW'">
          <el-option label="工资条详情页" :value="'1'"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="终端类型" prop="sourceType">
        <el-select class="item-choose" v-model="info.sourceType" clearable placeholder="请选择"  :disabled="type == 'VIEW'">
          <el-option label="PC端" :value="'0'" :disabled="true" />
          <el-option label="司机端" :value="'1'" />
          <el-option label="管理端" :value="'2'" :disabled="true" />
          <el-option label="客户端" :value="'3'" :disabled="true" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select class="item-choose" v-model="info.status" size="small" filterable clearable laceholder="请选择"  :disabled="type == 'VIEW'">
          <el-option label="启用" :value="'0'" />
          <el-option label="禁用" :value="'1'" />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="info.remark" placeholder="备注" clearable  :disabled="type == 'VIEW'" />
      </el-form-item>
      <el-form-item label="封面图" prop="surfaceDrawingUrls">
        <UploadImage :fileData="info.surfaceDrawingUrls" @handlePictureCardPreview="handlePictureCardPreview" @getFileData="(e) => getFileData(e, 'surfaceDrawingUrls')" title="封面图" :businessType="952587"></UploadImage>
      </el-form-item>
    </el-form>
    <div class="separatorVV" />

    <!-- (司机端)工资条详情页面 -->
    <div class="salary-config-app" v-if="info.no == 1 && info.sourceType == 1">
      <!-- 配置编辑区 -->
      <div class="config-editor">
        <h2>(司机端)工资条详情页配置</h2>

        <!-- 头部配置 -->
        <div class="config-section">
          <h3>操作</h3>
          <div class="form-group">
            <label>操作</label>
            <el-button type="success" @click="saveConfig"  size="mini" :disabled="type == 'VIEW'">处理配置</el-button>
            <el-button type="primary" @click="addCard"  size="mini" :disabled="type == 'VIEW'">添加卡片</el-button>
            <el-button type="info" @click="resetConfig"  size="mini" :disabled="type == 'VIEW'">重置</el-button>
          </div>
        </div>

        <!-- 警告文案 -->
        <div class="config-section">
          <h3>警告</h3>
          <div class="form-group">
            <label>警告文案</label>
            <el-input type="textarea" autosize placeholder="请输入内容" v-model="info.jsonContent.warningCopy" />
          </div>
        </div>

        <!-- 操作按钮文案 -->
        <div class="config-section">
          <h3>操作按钮</h3>
          <div class="form-group">
            <label>确认按钮文案</label>
            <el-input autosize placeholder="请输入内容" v-model="info.jsonContent.successButton" />
          </div>
          <div class="form-group">
            <label>反馈按钮文案</label>
            <el-input autosize placeholder="请输入内容" v-model="info.jsonContent.errorButton" />
          </div>
        </div>

        <!-- 头部配置 -->
        <div class="config-section">
          <h3>头部设置</h3>
          <div class="form-group">
            <label>背景颜色</label>
            <el-color-picker v-model="info.jsonContent.headerBgColor" show-alpha :predefine="predefineColors" @active-change="colorCustomization" />
          </div>
        </div>

        <!-- 卡片配置 -->
        <div class="config-section" v-for="(cardItems, cartIndex) in info.jsonContent.cardList" :key="cartIndex">
          <el-input v-model="cardItems.title" placeholder="卡片标题" style="padding-bottom: 10px;width: 60%" />
          <div v-for="(item, index) in cardItems.items" :key="index" class="form-row">
            <input v-model="item.label" placeholder="名称" />
            <input v-model="item.value" placeholder="映射值" :disabled="item.disabled" />
            <el-button @click="removeBasicItem(cardItems.items,index)" :disabled="item.disabled" type="danger" size="mini">删除行</el-button>
          </div>
          <el-button @click="addBasicItem(cardItems.items)" type="success" size="mini">添加行</el-button>
          <el-button @click="removeBasicItem(info.jsonContent.cardList,cartIndex)" type="danger"  size="mini">删除当前整个卡片</el-button>
        </div>
      </div>

      <!-- 实时预览区 -->
      <div class="preview-panel">
        <h2>小程序预览</h2>
        <div class="wx-preview">
          <div class="wx-container">
            <!-- 头部区域 -->
            <div class="wx-header" :style="{ backgroundColor: info.jsonContent.headerBgColor }">
              <div class="wx-header-content">
                <div class="wx-header-date">2025-06薪资</div>
                <div class="wx-header-amount">99999999</div>
              </div>
            </div>

            <!-- 卡片区域 -->
            <div class="wx-card-container">
              <div class="wx-card" v-for="(cardItems, cartIndex) in info.jsonContent.cardList" :key="cartIndex">
                <div class="wx-card-header">
                  <div class="wx-card-title">{{ cardItems.title }}</div>
                </div>
                <div class="wx-divider" />
                <div class="wx-cell-group">
                  <div v-for="(item, index) in cardItems.items" :key="index" class="wx-cell">
                    <div class="wx-cell-title">{{ item.label }}</div>
                    <div class="wx-cell-extra">{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 底部按钮 -->
            <div class="wx-action-buttons">
              <button class="wx-confirm-button">{{ info.jsonContent.successButton }}</button>
              <button class="wx-feedback-button">{{ info.jsonContent.errorButton }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <big-image ref="bigImg"></big-image>
  </el-drawer>
</template>

<script>
import UploadImage from '@/components/uploadImage'
import bigImage from '@/views/commonPop/bigImage'
import {getClone} from "@/utils/myJsonClone";
export default {
  components: {UploadImage,bigImage},
  data () {
    return {
      visible: false,
      type: '',
      formRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'change' }],
        no: [{ required: true, message: '请选择页面类型', trigger: 'change' }],
        sourceType: [{ required: true, message: '请选择终端类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        surfaceDrawingUrls: [{ required: true, message: '请上传封面图', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'change' }],
      },

      // (司机端)工资条详情页
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      info: {
        title: undefined,
        no: '1',
        sourceType: '1',
        status: '1',
        remark: undefined,
        surfaceDrawingUrls: undefined,
        jsonContent: {
          headerBgColor: "#ff7f00",
          warningCopy: '所有员工须在工资发放后72小时内完成确认逾期未确认者：首次将延迟发放3个工作日累计3次未确认将暂停次月工资发放请务必及时完成确认。',
          successButton: '签名确认',
          errorButton: '对工资有疑问',
          cardList: [
            {
              title: '基本信息',
              items: [
                { label: "姓名", value: "driverName",disabled: false },
                { label: "订单数", value: "orderNum",disabled: false },
                { label: "基本工资", value: "basicSalary",disabled: false },
                { label: "应出勤（天）", value: "beOnDutyDay",disabled: false },
                { label: "实出勤（天）", value: "actualAttendanceDay",disabled: false },
                { label: "事假天数", value: "leaveDays",disabled: false },
                { label: "年假天数", value: "annualLeaveDays",disabled: false },
                { label: "平时加班（H)", value: "regularOvertimeWork",disabled: false },
                { label: "周末加班（H)", value: "workOvertimeOnWeekends",disabled: false },
              ]
            },
            {
              title: '实际基本工资',
              items: [
                { label: "实际出勤工资", value: "baseFee",disabled: false },
                { label: "绩效奖罚金", value: "meritsFee",disabled: false },
                { label: "APP奖罚金", value: "appFee",disabled: false },
                { label: "安全奖罚金", value: "safetyRewards",disabled: false },
                { label: "加班费", value: "extraFee",disabled: false },
              ]
            },
            {
              title: '福利补助',
              items: [
                { label: "提成", value: "royaltyFee",disabled: false },
                { label: "租房费", value: "other1Fee",disabled: false },
                { label: "装卸费", value: "loadFee",disabled: false },
                { label: "住宿费", value: "stayFee",disabled: false },
                { label: "油耗奖励", value: "other2Fee",disabled: false }
              ]
            },
            {
              title: '应扣工资',
              items: [
                { label: "个税", value: "personalIncomeTax",disabled: false },
                { label: "其他费用", value: "otherExpenses",disabled: false },
                { label: "分摊水电费", value: "hydropower",disabled: false },
                { label: "社保/公积金", value: "deductionsFee",disabled: false },
              ]
            },
            {
              title: '借支',
              items: [
                { label: "借支", value: "driverBorrowing",disabled: false },
                { label: "借支备注", value: "borrowingRemark",disabled: false }
              ]
            },
            {
              title: '绩效考核管理',
              items: [
                { label: "事故次数", value: "accidentNumber",disabled: false },
                { label: "违章次数", value: "violationNumber",disabled: false },
                { label: "迟到次数", value: "theNumberOfTimesOneIsLate",disabled: false },
                { label: "绩效考核", value: "performanceAssessment",disabled: false },
              ]
            },
            {
              title: '其余信息',
              items: [
                { label: "应发合计", value: "shouldTotal",disabled: false },
                { label: "实发合计", value: "actualTotal",disabled: false },
                { label: "备注", value: "remark",disabled: false },
                { label: "银行卡号", value: "bankCard",disabled: false },
                { label: "确认状态", value: "driverConfirmationStateStr",disabled: false },
                { label: "异常反馈", value: "driverErrorRemark",disabled: false },
                { label: "驳回原因", value: "rejectionRemarks",disabled: false },
                { label: "签字图", value: "signatureDrawing",disabled: true }]
            },
          ]
        },
      },
    }
  },
  computed: {
    dictTypeMap: {
      get () { return this.$store.state.common.dictTypeMap }
    }
  },
  methods: {
    init(type,row) {
      // 重置
      this.info = this.$options.data().info

      // 是编辑或详情
      if (row && row.id) {
        this.$http({
          url: this.$http.adornUrl('/pageConfig/' + row.id),
          method: 'get'
        }).then(({ data }) => {
          data.jsonContent = JSON.parse(data.jsonContent);
          this.info = data
        }).finally(() => {})
      }

      this.type = type
      this.visible = true
    },
    handlePictureCardPreview(data) {
      this.$refs.bigImg.init(data.url)
    },
    getFileData(data, key) {
      this.info[key] = data.fileList
      this.$forceUpdate()
    },

    // 处理
    saveConfig() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let cloneInfo = getClone(this.info);
          cloneInfo.jsonContent = JSON.stringify(cloneInfo.jsonContent);
          this.$http({
            url: this.$http.adornUrl('/pageConfig'),
            method: cloneInfo.id ? 'put' : 'post',
            data: cloneInfo
          }).then(({ data }) => {
            if (data) {
              this.$message.success('处理成功')
              this.$emit('sizeChangeHandle',20)
              this.visible = false
            } else {
              this.$message.error('处理失败')
            }
          }).finally(() => {})
        } else {
          return false;
        }
      });
    },
    resetConfig() {
      if (confirm("确定要重置为默认配置吗?")) {
        this.info.jsonContent = this.$options.data().info.jsonContent
      }
    },
    addCard() {
      this.info.jsonContent.cardList.push({title: '卡片标题请输入',items: []})
    },
    addBasicItem(item) {
      item.push({ label: "", value: "",disabled: false });
    },
    removeBasicItem(item,index) {
      item.splice(index, 1);
    },
    colorCustomization(color) {
      this.info.jsonContent.headerBgColor = color;
    },

  }
}
</script>
<style lang="less">
.separatorVV {
  border-top: 2px solid rgba(0, 0, 0, 0.34);
  margin: 10px 0;
}

.salary-config-app {
  display: flex;
  font-family: Arial, sans-serif;
  height: 100%;
}
.config-editor {
  flex: unset;
}
.config-section {
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.form-group label {
  margin-right: 10px;
  min-width: 80px;
  white-space: nowrap;
}
.form-row {
  display: flex;
  margin-bottom: 10px;
}
.form-row input {
  flex: 1;
  margin-right: 10px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.actions {
  border-top: 1px solid #eee;
  margin-right: 20px;
}
.wx-section h2 {
  font-size: 16px;
  color: #333;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.info-row span:first-child {
  color: #666;
}
.info-row span:last-child {
  font-weight: 500;
}

/* 微信小程序预览样式 */
.preview-panel {
  width: -webkit-fill-available;
  padding: 20px;
  position: relative;
}
.wx-preview {
  position: relative;
  top: 30px;
  left: 10px;
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}
/* 头部区域 */
.wx-header {
  padding: 80px 30px;
  color: white;
  text-align: center;
  position: relative;
  margin-bottom: 5px;
}
.wx-header-date {
  font-size: 18px;
  margin-bottom: 15px;
}
.wx-header-amount {
  font-size: 36px;
  font-weight: bold;
}
/* 卡片样式 */
.wx-card {
  background-color: white;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.wx-card-header {
  padding: 12px 15px;
}
.wx-card-title {
  font-weight: bold;
  font-size: 16px;
}
.wx-divider {
  height: 1px;
  background-color: #eee;
  margin: 0;
}
/* 单元格样式 */
.wx-cell-group {
  padding: 0 15px;
}
.wx-cell {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}
.wx-cell:last-child {
  border-bottom: none;
}
.wx-cell-title {
  padding: 20rpx 30rpx;
  margin: 0;
  border-radius: 0;
  color: inherit!important;
  background: 0 0!important;
  font-size: inherit;
  font-weight: 400;
  line-height: inherit;
  text-align: inherit;
  text-decoration: none;
  overflow: visible;
  min-height: 0!important;
  width: auto!important;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
.wx-cell-extra {
  color: rgba(0, 0, 0, 0.45);
}
/* 按钮样式 */
.wx-action-buttons {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: white;
  position: sticky;
  bottom: 0;
}
.wx-confirm-button {
  background-color: #ff7f00;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 0;
  width: 48%;
  font-size: 14px;
}
.wx-feedback-button {
  background-color: white;
  color: #ff7f00;
  border: 1px solid #ff7f00;
  border-radius: 4px;
  padding: 10px 0;
  width: 48%;
  font-size: 14px;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .salary-config-app {
    flex-direction: column;
  }
  .preview-panel {
    width: 100%;
    margin-top: 20px;
  }
  .wx-preview {
    margin: 0 auto;
  }
}
</style>
